var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5309 5.98333C19.6476 2.89167 17.0226 0.5 13.9892 0.5C10.9559 0.5 8.27256 2.95 8.44756 5.98333C8.5059 6.625 9.08923 9.65833 9.08923 9.65833C9.5559 12.2833 11.3059 14.5 13.9892 14.5C16.6726 14.5 18.4226 12.2833 18.8892 9.6C18.8892 9.6 19.4726 6.56667 19.5309 5.98333Z",
    stroke: "#121212",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4056 27.3333H0.572266L1.21393 22.55C1.5056 20.975 2.9056 20.0417 4.4806 19.6917L13.9889 18L23.4973 19.6917C25.0723 20.0417 26.4723 20.975 26.7056 22.55L27.4056 27.3333Z",
    stroke: "#121212",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.6bf0e2992986ad402640f874ff6e2788.svg";
export { ForwardRef as ReactComponent };